import Log from 'cgil-log';

export const APP = 'smartmap';
export const VERSION = '1.1.3'; // migration to MN95
export const BUILD_DATE = '28-04-2022';
export const DEV = process.env.NODE_ENV === 'development';
export const DEFAULT_BASE_SERVER_URL = DEV ? `https://${APP}.lausanne.ch/api` : '/api';
export const getLog = (ModuleName, verbosityDev, verbosityProd) => (
  (DEV) ? new Log(ModuleName, verbosityDev) : new Log(ModuleName, verbosityProd)
);

// export const BASE_PATH = DEV ? '' : '/carte_mn95/';
export const BASE_PATH = DEV ? '' : '';

export const BASE_REST_API_URL = DEV ? 'https://smartmap.lausanne.ch/api/geo' : '/api/geo';
